import React from "react";
import { Box, alpha } from "@mui/material";
import { progressGradient } from "@karda/design-tokens";
import {
  progressGradientAnimation,
  progressSweepAnimation,
} from "../animations";

export const ProgressBar: React.FC<{
  progress: number;
  /** No estimate available — sweep instead of reporting a percentage. */
  indeterminate?: boolean;
}> = ({ progress, indeterminate = false }) => (
  <Box
    sx={{
      mt: 1.5,
      height: 6,
      borderRadius: 3,
      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        height: "100%",
        width: indeterminate ? "30%" : `${progress}%`,
        borderRadius: 3,
        background: (theme) =>
          progressGradient(theme.palette.primary.main, theme.palette.primary.light),
        backgroundSize: "200% 100%",
        animation: indeterminate
          ? `${progressSweepAnimation} 1.8s ease-in-out infinite`
          : `${progressGradientAnimation} 2s ease infinite`,
        transition: indeterminate ? "none" : "width 0.3s ease",
      }}
    />
  </Box>
);
